import { useAtom } from "jotai";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect } from "react";

import { startAlimProcess } from "@/businessLogics/alimLogic";
import { alimModalStepAtom, showAlimModalAtom } from "@/states/notification";
import HubLandingTemplate from "src/pages/HubLanding";
import { loginRequiredSSR } from "@/businessLogics/_common/next/validate";

const Home = ({ userInfo, query }: { userInfo: UserInfo; query: any }) => {
  const router = useRouter();
  const [, setShowModal] = useAtom(showAlimModalAtom);
  const [, setStep] = useAtom(alimModalStepAtom);

  /**
   * 사전 알림 신청 로직
   */
  useEffect(() => {
    if (query?.noticeModal === "true" && userInfo) {
      startAlimProcess(userInfo, "designer", setShowModal, setStep);
      router.replace("/", undefined, { shallow: true });
    }
  }, []);

  // useEffect(() => {
  //   if (router.asPath.includes("course-div"))
  //     router.push("/", undefined, { shallow: true }), [router.asPath];
  // });

  return (
    <>
      <Head>
        <title>SW캠프 | 직장병행 IT취업 부트캠프</title>
        <meta
          name="description"
          content="IT직무 커리어 전환은 SW캠프에서! 직장과 병행하며 꿈꾸던 커리어를 실무 그대로 경험해보세요."
        />
        <meta property="og:title" content="SW캠프 | 직장병행 IT취업 부트캠프" />
        <meta
          property="og:description"
          content="IT직무 커리어 전환은 SW캠프에서! 직장과 병행하며 꿈꾸던 커리어를 실무 그대로 경험해보세요."
        />
        <meta
          property="og:image"
          content={`${process.env.CDN_BASE_URL}/swcamp/hub_og_image.png`}
        />
        <meta property="og:site_name" content="SW캠프" />
        <meta
          name="keywords"
          content="PM, PM교육, PM강의, PM부트캠프 스파르타코딩클럽, 서비스기획자, PO, 서비스기획교육, 데이터, 개발, PM코딩, PM채용, PM취업, PO취업, 서비스기획자 취업, 프로덕트매니저, 프로덕트오너, 프로젝트매니저, 기획자, productmanager, 프로덕트 매니지먼트, 프로젝트 매니지먼트, 피그마, 사업기획, PM직무, 그로스해킹, 애자일, 마케터"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://swcamp.spartacodingclub.kr/" />
        <meta
          name="naver-site-verification"
          content="825fd698b7789dcdb41d72934bc879036f336c73"
        />
      </Head>
      <HubLandingTemplate userInfo={userInfo} />
    </>
  );
};

export const getServerSideProps = async ({
  req,
  res,
  resolvedUrl,
  query,
}: GetServerSidePropsContext) => {
  const [userInfo] = loginRequiredSSR(req, res, resolvedUrl);

  return {
    props: {
      userInfo,
      query,
    },
  };
};

export default Home;
